import PropTypes from 'prop-types';
import Text from '../atoms/Text';

const Message = ({ padding, bgColor, textColor, children, ...property }) => (
    <div
        className={`w-full ${padding} ${bgColor} ${textColor}  ${property.className}`}
    >
        <Text
            variant="bodySmall"
            className="text-sm md:text-base text-center"
        >
            {children}
        </Text>
    </div>
);

export default Message;

Message.propTypes = {
    className: PropTypes.string,
    padding: PropTypes.string,
    bgColor: PropTypes.string,
    textColor: PropTypes.string,
    children: PropTypes.node
};
